import { render, staticRenderFns } from "./FollowupList.vue?vue&type=template&id=77b02d94"
import script from "./FollowupList.vue?vue&type=script&lang=js"
export * from "./FollowupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports